import { createSlice } from "@reduxjs/toolkit";
import { BasicTDHCalculation, BasicWellInflowCalculation, DepletionCurveGraphData, InflowData, IPRGraphData, IPRMethodology, WellInflowInfo } from "../../model/calculations/calculation";

interface BasicCalculationState {
    loading: boolean;
    error: string | null;
    BasicWellInflowCalculation: BasicWellInflowCalculation | null,
    IPRSelection: IPRMethodology | "";
    basicTDHCalculation: BasicTDHCalculation | null;
    depletionPressure: number | null;
    depletionPercentage: number | null;
    futureProductionRate: number;
    futureBHP: number | null;
    BasicCalculationComplete: boolean;
    wellInflowData: WellInflowInfo[] | null;
    depletionCurve: DepletionCurveGraphData | null;
    iprCurve: IPRGraphData | null;
    inflowData: InflowData | null;
    showIPRPlotInMainReport: boolean;
    showDepletionPlotInMainReport: boolean;
}

export const initialState: BasicCalculationState = {
    loading: false,
    error: null,
    BasicWellInflowCalculation: null,
    IPRSelection: "Wiggins",
    basicTDHCalculation: null,
    depletionPressure: null,
    depletionPercentage: null,
    futureProductionRate: 1000,
    futureBHP: null,
    BasicCalculationComplete: false,
    wellInflowData: [],
    iprCurve: null,
    depletionCurve: null,
    inflowData: null,
    showIPRPlotInMainReport: false,
    showDepletionPlotInMainReport: false
};


const basicCalculationSlice = createSlice({
    name: "basicCalculation",
    initialState,
    reducers: {
        resetBasicCalculations: () => ({
            ...initialState
        }),
        setBasicWellInflowCalculation: (state, action) => {
            state.BasicWellInflowCalculation = action?.payload;
        },
        setBasicWellInflowCalculation2: (state, action) => {
            state.BasicWellInflowCalculation = action?.payload;
        },
        setBasicTDHCalculation: (state, action) => {
            state.basicTDHCalculation = action?.payload
        },
        setBasicTDHCalculationOutput: (state, action) => {
            state.basicTDHCalculation = {
                ...state.basicTDHCalculation,
                pipNew: action?.payload.pipNew ?? state?.basicTDHCalculation?.pipNew,
                pip: action?.payload.pip ?? state?.basicTDHCalculation?.pip,
                tubingHead: action?.payload.tubingHead ?? state?.basicTDHCalculation?.tubingHead,
                tdh: action?.payload.tdh ?? state?.basicTDHCalculation?.tdh,
                productionLevel: action?.payload.productionLevel ?? state?.basicTDHCalculation?.productionLevel,
                frictionLoss: action?.payload.frictionLoss ?? state?.basicTDHCalculation?.frictionLoss,
                systemTDH: action?.payload.systemTDH
            }
        },
        setBasicWellIPRDepletionPressure: (state, action) => {
            state.depletionPressure = action?.payload;
        },
        setBasicWellIPRDepletionPercentage: (state, action) => {
            state.depletionPercentage = action?.payload;
        },
        setBasicWellIPRFutureProdRate: (state, action) => {
            state.futureProductionRate = action?.payload;
        },
        setBasicWellIPRFutureBHP: (state, action) => {
            state.futureBHP = action?.payload;
        },
        setBasicCalculationComplete: (state, action) => {
            state.BasicCalculationComplete = action?.payload;
        },
        setBasicWellInflowData: (state, action) => {
            state.wellInflowData = action?.payload
        },
        setBasicIPRMethodologySelection: (state, action) => {
            state.IPRSelection = action?.payload
        },
        setBasicTDHDesiredPIP: (state, action) => {
            if (state.basicTDHCalculation) {
                state.basicTDHCalculation = {
                    ...state.basicTDHCalculation,
                    desrdPIP: action?.payload
                }
            }
        },
        setBasicNewTDH: (state, action) => {
            if (state.basicTDHCalculation) {
                state.basicTDHCalculation = {
                    ...state.basicTDHCalculation,
                    newTDH: action?.payload
                }
            }
        },
        setIPRChartData: (state, action) => {
            state.iprCurve = action?.payload
        },
        setDepletionChartData: (state, action) => {
            state.depletionCurve = action?.payload
        },
        setShowIPRPlotInMainReport: (state, action) => {
            state.showIPRPlotInMainReport = action?.payload
        },
        setShowDepletionPlotInMainReport: (state, action) => {
            state.showDepletionPlotInMainReport = action?.payload
        },
    },
});
export const {
    resetBasicCalculations,
    setBasicWellInflowCalculation,
    setBasicWellInflowCalculation2,
    setBasicTDHCalculation,
    setBasicTDHCalculationOutput,
    setBasicWellIPRDepletionPressure,
    setBasicWellIPRDepletionPercentage,
    setBasicWellIPRFutureProdRate,
    setBasicWellIPRFutureBHP,
    setBasicCalculationComplete,
    setBasicWellInflowData,
    setBasicIPRMethodologySelection,
    setBasicTDHDesiredPIP,
    setBasicNewTDH,
    setIPRChartData,
    setDepletionChartData,
    setShowIPRPlotInMainReport,
    setShowDepletionPlotInMainReport
} = basicCalculationSlice.actions;
export default basicCalculationSlice.reducer;
